export default "__VITE_ASSET__hGxfpHXQB1mRKJWHu5xV3Q__";